/**
 * localStorage for conveniences, never requirements (ENG-3359, ENG-3411).
 *
 * Touching `localStorage` throws where site data is blocked, and an unguarded read on a render path
 * takes the whole page down for the sake of a remembered preference. These swallow that: a read
 * comes back null and a write or a removal is dropped, so the caller behaves as it would on a first
 * visit.
 *
 * ENG-3411: the same held at startup, where it cost the whole console rather than one card. App's init
 * effect read a remembered join token and extension id before it registered the auth listener, so a
 * browser blocking site data got the root "Something went wrong" instead of the sign-in screen.
 * `storage.guard.test.ts` now fails on any storage access outside a `try`, which is what these are for.
 *
 * Same guard `lib/activeTenant.ts` and `usePagedRows` already write inline.
 */
export function readStored(key: string): string | null {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function writeStored(key: string, value: string): void {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    // Not persisting is fine: the preference just does not outlive this page.
  }
}

export function removeStored(key: string): void {
  try {
    window.localStorage.removeItem(key);
  } catch {
    // Nothing to clear: a value this page cannot reach cannot be read back by it either.
  }
}
